import { Button } from '@chakra-ui/react'


export const ColumnSettingsButton = ({onClick}) => {
    console.log('onClick prop =', onClick)
    
return (
    <Button 
        size='sm'
        colorScheme='teal'
        mr='4'
        variant='outline'
        onClick={onClick}>
        Column Settings
        </Button>
)
}